import { render, staticRenderFns } from "./SectionMailbox.vue?vue&type=template&id=dd6cfe78&scoped=true&"
import script from "./SectionMailbox.vue?vue&type=script&lang=js&"
export * from "./SectionMailbox.vue?vue&type=script&lang=js&"
import style0 from "./SectionMailbox.vue?vue&type=style&index=0&id=dd6cfe78&prod&lang=sass&scoped=true&"
import style1 from "./SectionMailbox.vue?vue&type=style&index=1&id=dd6cfe78&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6cfe78",
  null
  
)

export default component.exports